import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=736e5f42&scoped=true&"
import script from "./CartMenu.vue?vue&type=script&lang=js&"
export * from "./CartMenu.vue?vue&type=script&lang=js&"
import style0 from "./CartMenu.vue?vue&type=style&index=0&id=736e5f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e5f42",
  null
  
)

export default component.exports